import { render, staticRenderFns } from "./member-item.vue?vue&type=template&id=9bdfaf5a&scoped=true&"
import script from "./member-item.vue?vue&type=script&lang=js&"
export * from "./member-item.vue?vue&type=script&lang=js&"
import style0 from "./member-item.vue?vue&type=style&index=0&id=9bdfaf5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bdfaf5a",
  null
  
)

export default component.exports